import { Outlet } from 'react-router-dom'

import { MyDocumentsRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/documents/lib/My_documentsCollectionsBootstrap'

export interface Tab {
  href: string
  name: string
}

const Container = () => {
  const { employee: sessionEmployee } = useCurrentSession()

  const { data, loading } = useQuery(MyDocumentsRootPageDocument, {
    variables: { employeeId: sessionEmployee?.id ?? '' },
    skip: !sessionEmployee?.id,
  })

  if (loading && !data) return <Loading />

  const policies = data?.employees?.employee?._policies
  const canSeeDocuments =
    (policies?.seeDocuments?.can ||
      policies?.seeEmployeeDocumentsWithoutFolder?.can ||
      policies?.seeAnyEmployeeDocumentsByFolder?.can) ??
    false

  if (!sessionEmployee || !canSeeDocuments) return <NotFound />

  return (
    <AuthorizeUser authorizeFn={() => canSeeDocuments}>
      <Outlet />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
